import axios from "axios";
import { saveAs } from "file-saver";

// const downloadAttachments = async(e) => {
//     await fetch(`${process.env.REACT_APP_API_URL}/${e}`)?.then(response => {
//       response?.blob()?.then(blob => {
//         const fileURL = window.URL.createObjectURL(blob);

//         let alink = document.createElement('a');
//         alink.href = fileURL;
//         alink.download = `${process.env.REACT_APP_API_URL}/${e}`;
//         alink.click();
//       }).catch((err) => {
//
//       })
//     })
//   };

// const downloadAttachments = async (e) => {
//   try {
//     const url = `${process.env.REACT_APP_API_URL}/${e}`

//     const response = await axios({
//       url,
//       method: 'GET',
//     });
//     const blob = new Blob([response.data], {
//       type: response.headers['text/plain'],
//     });
//     const link = document.createElement('a');
//     link.href = URL.createObjectURL(blob);
//     link.setAttribute('download', 'download');
//     document.body.appendChild(link);
//     link.click();
//     link.remove();
//   } catch (error) {
//     console.error(error);
//   } finally {
//   //  setLoading(false);
//   }
// };
//   const downloadAttachments = async (e) => {
// const data ={
//   filename:e
// }
//     await axios({
//       method: "get", //you can set what request you want to be
//       url: `http://192.168.202.198:9093/api/UploadFile/DownloadFile`,
//       // url:`${process.env.REACT_APP_API_URL}/api/UploadFile/DownloadFile`,
//       headers: {
//         Authorization: `Bearer ${localStorage.getItem("user_token")}`,
//       },
//             params: data,

//     })
//       .then(async (res) => {

//       })
//       .catch((err) => {
//       });

//   }
const downloadAttachments = async (e) => {
  const filenameWithoutPrefix = e?.substring("Uploads\\".length);

  const data = {
    filename: filenameWithoutPrefix,
  };

  // const data = {
  //   filename: e,
  // };
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/api/UploadFile/DownloadFile`,
      // `https://i2p-uat.frieslandcampina.com.pk/api/UploadFile/DownloadFile`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("user_token")}`,
        },
        params: data,
        responseType: "blob", // Set the response type to 'blob' for binary data
      }
    );

    // Create a blob object from the response data
    const blob = new Blob([response.data], {
      type: response.headers["content-type"],
    });

    // Create a temporary URL for the blob
    const url = window.URL.createObjectURL(blob);

    // Create a hidden anchor element
    const a = document.createElement("a");
    a.href = url;
    a.download = e; // Set the desired file name

    // Programmatically click the anchor to initiate the download
    a.click();

    // Release the object URL to free up resources
    window.URL.revokeObjectURL(url);
  } catch (err) {
    console.log(err);
  }
};

// const downloadAttachments = async (e) => {

//      const url = `${process.env.REACT_APP_API_URL}/${e}`
//    const fileName = url.split("/").pop();
//     saveAs( url , fileName)

// }

export default downloadAttachments;
